import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-tok-header',
  templateUrl: './tok-header.component.html',
  styleUrls: ['./tok-header.component.scss'],
})
export class TokHeaderComponent implements OnInit, OnChanges {
  @Input()
  public title: string;
  public sanitizedTitle: SafeHtml = '';

  @Input()
  public subTitle: string;

  @Input()
  public list: string[];

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.title && this.title) {
      this.sanitizedTitle = this.sanitizer.bypassSecurityTrustHtml(this.title);
    }
  }
}
